<template>
  <div>
    <compact-chip
      v-if="stimulus.ignore_optin"
      label="SEM OPTIN"
      tooltip="Optin Ignorado"
      color="orange"
      text-color="red"
    ></compact-chip>

    <compact-chip
      v-if="stimulus.hot"
      label="HOT"
      tooltip="Estímulo para contatos localizados"
      color="red"
    ></compact-chip>

    <compact-chip
      v-if="stimulus.daily_budget"
      :label="`R$ ${$options.filters.numeral(
        stimulus.daily_budget,
        '0,0[.]00',
      )}`"
      tooltip="Valor de orçamento diário"
      color="green"
    ></compact-chip>

    <compact-chip
      v-if="stimulus.filters.min_quality"
      :label="`>= ${stimulus.filters.min_quality}`"
      tooltip="Qualidade Mínima"
      color="blue"
    ></compact-chip>

    <compact-chip
      v-if="stimulus.filters.max_quality"
      :label="`< ${stimulus.filters.max_quality}`"
      tooltip="Qualidade Máxima"
      color="blue"
    ></compact-chip>

    <compact-chip
      v-if="stimulus.filters.min_stimulation"
      :label="`>= ${stimulus.filters.min_stimulation}`"
      tooltip="Mínimo de Notificações"
      color="purple"
    ></compact-chip>

    <compact-chip
      v-if="stimulus.filters.max_stimulation"
      :label="`< ${stimulus.filters.max_stimulation}`"
      tooltip="Máximo de Notificações"
      color="purple"
    ></compact-chip>

    <compact-chip
      v-if="stimulus.filters.min_digit"
      :label="`>= ${stimulus.filters.min_digit}`"
      tooltip="Dígito Verificador Mínimo"
      color="orange"
    ></compact-chip>

    <compact-chip
      v-if="stimulus.filters.max_digit"
      :label="`<= ${stimulus.filters.max_digit}`"
      tooltip="Dígito Verificador Máximo"
      color="orange"
    ></compact-chip>

    <compact-chip
      v-if="stimulus.filters.tags_v2"
      v-for="(tags_v2, index) in getFilters(stimulus.filters.tags_v2)"
      :key="'tags_v2-' + index"
      :label="tags_v2"
      tooltip="Tag de Deal"
      color="indigo"
    ></compact-chip>

    <compact-chip
      v-if="stimulus.filters.contact_tags_v2"
      v-for="(contact_tags_v2, index) in getFilters(stimulus.filters.contact_tags_v2)"
      :key="'contact_tags_v2-' + index"
      :label="contact_tags_v2"
      tooltip="Tag de Contato"
      color="teal"
    ></compact-chip>

    <compact-chip
      v-if="stimulus.filters.customer_tag"
      v-for="(customer_tag, index) in getFilters(stimulus.filters.customer_tag)"
      :key="'customer_tag-' + index"
      :label="customer_tag"
      tooltip="Tag de Cliente"
      color="teal"
    ></compact-chip>

    <compact-chip
      v-if="stimulus.filters.campaign"
      v-for="(campaign, index) in getFilters(stimulus.filters.campaign)"
      :key="'campaign-' + index"
      :label="campaign"
      tooltip="Campanha da Deal"
      color="brown"
    ></compact-chip>

    <compact-chip
      v-if="stimulus.filters.segments"
      v-for="(segment, index) in getFilters(stimulus.filters.segments)"
      :key="'segment-' + index"
      :label="segment"
      tooltip="Segmentos"
      color="deep-orange"
    ></compact-chip>

    <compact-chip
      v-if="stimulus.filters.creditor_profiles"
      v-for="(creditorProfile, index) in getFilters(stimulus.filters.creditor_profiles)"
      :key="'creditor_profiles-' + index"
      :label="creditorProfile"
      tooltip="Perfil do Credor"
      color="light-green"
    ></compact-chip>

    <compact-chip
      v-if="stimulus.filters.creditors_mode"
      :label="stimulus.filters.creditors_mode"
      tooltip="Abordar Credor"
      color="lime"
    ></compact-chip>

    <compact-chip
      v-if="
        stimulus.filters.min_interaction_days &&
        !stimulus.filters.exclude_interactions
      "
      :label="`>= ${stimulus.filters.min_interaction_days}`"
      tooltip="Tempo de interação Mínimo"
      color="yellow"
    ></compact-chip>

    <compact-chip
      v-if="
        stimulus.filters.max_interaction_days &&
        !stimulus.filters.exclude_interactions
      "
      :label="`< ${stimulus.filters.max_interaction_days}`"
      tooltip="Tempo de interação Máximo"
      color="yellow"
    ></compact-chip>

    <compact-chip
      v-if="stimulus.filters.exclude_interactions"
      label="SEM_INTERAÇÃO"
      tooltip="Público sem interação"
      color="orange"
    ></compact-chip>

    <compact-chip
      v-if="stimulus.filters.payment_expired_days"
      :label="`${stimulus.filters.payment_expired_days}`"
      tooltip="Dias do últ. Acordo"
      color="brown"
    ></compact-chip>

    <compact-chip
      v-if="
        stimulus.filters.min_interaction_days_sms_click &&
        !stimulus.filters.exclude_interactions_sms_click
      "
      :label="`>= ${stimulus.filters.min_interaction_days_sms_click}`"
      tooltip="(Click no link do sms) Tempo de interação Mínimo"
      color="yellow"
    ></compact-chip>

    <compact-chip
      v-if="
        stimulus.filters.max_interaction_days_sms_click &&
        !stimulus.filters.exclude_interactions_sms_click
      "
      :label="`< ${stimulus.filters.max_interaction_days_sms_click}`"
      tooltip="(Click no link do sms) Tempo de interação Máximo"
      color="yellow"
    ></compact-chip>

    <compact-chip
      v-if="stimulus.filters.exclude_interactions_sms_click"
      label="SEM_INTERAÇÃO_SMS_CLICK"
      tooltip="Público sem interação de clique de SMS"
      color="orange"
    ></compact-chip>

    <compact-chip
      v-if="
        stimulus.filters.min_interaction_days_email_open &&
        !stimulus.filters.exclude_interactions_email_open
      "
      :label="`>= ${stimulus.filters.min_interaction_days_email_open}`"
      tooltip="(Abertura de Email) Tempo de interação Mínimo"
      color="yellow"
    ></compact-chip>

    <compact-chip
      v-if="
        stimulus.filters.max_interaction_days_email_open &&
        !stimulus.filters.exclude_interactions_email_open
      "
      :label="`< ${stimulus.filters.max_interaction_days_email_open}`"
      tooltip="(Abertura de Email) Tempo de interação Máximo"
      color="yellow"
    ></compact-chip>

    <compact-chip
      v-if="stimulus.filters.exclude_interactions_email_open"
      label="SEM_INTERAÇÃO_EMAIL_OPEN"
      tooltip="Público sem interação de Abertura de Email"
      color="orange"
    ></compact-chip>

    <compact-chip
      v-if="
        stimulus.filters.min_interaction_days_ura_answer &&
        !stimulus.filters.exclude_interactions_ura_answer
      "
      :label="`>= ${stimulus.filters.min_interaction_days_ura_answer}`"
      tooltip="(Resposta na URA) Tempo de interação Mínimo"
      color="yellow"
    ></compact-chip>

    <compact-chip
      v-if="
        stimulus.filters.max_interaction_days_ura_answer &&
        !stimulus.filters.exclude_interactions_ura_answer
      "
      :label="`< ${stimulus.filters.max_interaction_days_ura_answer}`"
      tooltip="(Resposta na URA) Tempo de interação Máximo"
      color="yellow"
    ></compact-chip>

    <compact-chip
      v-if="stimulus.filters.exclude_interactions_ura_answer"
      label="SEM_INTERAÇÃO_URA_ANSWER"
      tooltip="Público sem interação de Resposta de URA"
      color="orange"
    ></compact-chip>

    <compact-chip
      v-if="
        stimulus.filters.min_interaction_days_whatsapp_view &&
        !stimulus.filters.exclude_interactions_whatsapp_view
      "
      :label="`>= ${stimulus.filters.min_interaction_days_whatsapp_view}`"
      tooltip="(Visualização do WhatsApp) Tempo de interação Mínimo"
      color="yellow"
    ></compact-chip>

    <compact-chip
      v-if="
        stimulus.filters.max_interaction_days_whatsapp_view &&
        !stimulus.filters.exclude_interactions_whatsapp_view
      "
      :label="`< ${stimulus.filters.max_interaction_days_whatsapp_view}`"
      tooltip="(Visualização do WhatsApp) Tempo de interação Máximo"
      color="yellow"
    ></compact-chip>

    <compact-chip
      v-if="stimulus.filters.exclude_interactions_whatsapp_view"
      label="SEM_INTERAÇÃO_WHATS_VIEW"
      tooltip="Público sem interação de Visualização do WhatsApp"
      color="orange"
    ></compact-chip>

    <compact-chip
      v-if="
        stimulus.filters.min_interaction_days_email_click &&
        !stimulus.filters.exclude_interactions_email_click
      "
      :label="`>= ${stimulus.filters.min_interaction_days_email_click}`"
      tooltip="(Clique no Email) Tempo de interação Mínimo"
      color="yellow"
    ></compact-chip>

    <compact-chip
      v-if="
        stimulus.filters.max_interaction_days_email_click &&
        !stimulus.filters.exclude_interactions_email_click
      "
      :label="`< ${stimulus.filters.max_interaction_days_email_click}`"
      tooltip="(Clique no Email) Tempo de interação Máximo"
      color="yellow"
    ></compact-chip>

    <compact-chip
      v-if="stimulus.filters.exclude_interactions_email_click"
      label="SEM_INTERAÇÃO_EMAIL_CLICK"
      tooltip="Público sem interação de Clique no Email"
      color="orange"
    ></compact-chip>

    <compact-chip
      v-if="stimulus.filters.max_contact_count"
      :label="`<= ${stimulus.filters.max_contact_count}`"
      tooltip="Máximo de contatos por cliente"
      color="cyan"
    ></compact-chip>

    <compact-chip
      v-if="stimulus.filters.contact_age"
      :label="`<= ${stimulus.filters.contact_age}`"
      tooltip="Idade do contato"
      color="blue-grey"
    ></compact-chip>

    <compact-chip
      v-if="stimulus.filters.responsible_types"
      v-for="(responsible_types, index) in stimulus.filters.responsible_types"
      :key="'responsible_types-' + index"
      :label="responsible_types"
      tooltip="Tipo do contato"
      color="blue"
    ></compact-chip>

    <compact-chip
      :key="'contacts_source-' + contacts_source.id"
      v-if="stimulus.filters.contacts_source"
      v-for="contacts_source in stimulus.filters.contacts_source"
      :label="contacts_source"
      tooltip="Origem do contato"
      color="pink"
    ></compact-chip>

    <compact-chip
      v-if="
        stimulus.filters.min_payment_expired_days ||
        stimulus.filters.max_payment_expired_days
      "
      :label="`Quebra: ${[
        stimulus.filters.min_payment_expired_days,
        stimulus.filters.max_payment_expired_days,
      ]
        .filter((v) => v != null && v !== '')
        .join(' - ')}`"
      :tooltip="`Quebra ${getExpiredTooltip(stimulus)} dias.`"
      color="red"
    ></compact-chip>

    <compact-chip
      v-if="
        stimulus.filters.days_to_wait != null &&
        stimulus.filters.days_to_wait !== ''
      "
      :label="`Espera: ${stimulus.filters.days_to_wait}`"
      tooltip="Dias mínimos de espera desde a última notificação."
      color="red"
    ></compact-chip>
  </div>
</template>

<script>
// Cores para os chips aqui: https://v15.vuetifyjs.com/en/framework/colors/#material-colors

import CompactChip from "@/components/ui/CompactChip.vue";

export default {
  name: "stimulus-chips",
  components: {
    CompactChip,
  },
  props: {
    stimulus: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getFilters(obj) {
      if (typeof obj == "string") {
        return [obj];
      } else {
        return obj;
      }
    },
    getExpiredTooltip(item) {
      const min = item.filters.min_payment_expired_days;
      const max = item.filters.max_payment_expired_days;
      const hasMin = min != null && min !== "";
      const hasMax = max != null && max !== "";

      if (hasMin && hasMax) return `de ${min} até ${max}`;
      if (hasMin) return `mínima de ${min}`;
      if (hasMax) return `máxima de ${max}`;
      return "";
    },
  },
};
</script>

<style scoped></style>
